import { AppDispatch } from '../index';
import API from '@/app/lib/axios';

import { urls } from '../urls';

import { DictionariesSlice } from '../controllers/DictionariesSlice';

export const loadCountries = () => async (dispatch: AppDispatch) => {
  try {
    const response = await API.get(`${urls.countries}`);
    dispatch(DictionariesSlice.actions.loadCountries(response));
  } catch (err: any) {
    console.error(`Error upon Load Dictionaries Countries ${err}`);
  }
};

export const loadTimezones = () => async (dispatch: AppDispatch) => {
  try {
    const response = await API.get(`${urls.timezones}`);
    dispatch(DictionariesSlice.actions.loadTimezones(response));
  } catch (err: any) {
    console.error(`Error upon Load Dictionaries Countries ${err}`);
  }
};
